import React from "react";
import {connect} from "react-redux";
import SimpleSelect from "./SimpleSelect";
import {LANGUAGE_TOKEN} from "../../redux/slice/languageSlice";
import {styled} from "@mui/material";
import {RootState} from "../../redux/store";
import getFullRouteFromPath from "../../routing/getFullRouteFromPath";
import useRedirect from "../../routing/useRedirect";
import {useLocation} from "react-router-dom";

const Root = styled(SimpleSelect)(({theme}) => ({
    root: {
        alignSelf: 'center',
        [theme.breakpoints.up('sm')]: {
            display: 'flex',
        },
        "&:hover": {

            color: theme.palette.text.primary
        },
        "&:active": {

            color: theme.palette.text.primary
        },
    },
}));

interface IProps {
    languageToken: LANGUAGE_TOKEN;
}

function LanguageSelect({languageToken}: IProps) {
    const {search} = useLocation();
    const redirect = useRedirect();
    const {pathname} = useLocation();

    const handleRedirectForNextLanguage = (value: string) => {
        const activeRoute = getFullRouteFromPath(pathname);
        const nextLanguageToken = value === 'English' ? 'EN' : 'DE'
        redirect(activeRoute, {replace: true}, search, nextLanguageToken);
    }

    // todo move
    const availableLanguages = [
        'English', 'Deutsch'
    ]

    return <Root
        // todo move
        value={languageToken === 'EN' ? 'English' : 'Deutsch'}
        texts={availableLanguages}
        onSelect={handleRedirectForNextLanguage}
    />
}

const mapStateToProps = (state: RootState) => ({
    languageToken: state.language.languageToken,
});

const mapActionsToProps = {};


export default connect(mapStateToProps, mapActionsToProps)(LanguageSelect);
